<template>
    <article class="blog__articles-item d-flex flex-column">
        <a :href="articleLink" class="blog__articles-header" :style="headerStyles" />
        <div class="blog__articles-content d-flex flex-column">
            <article-meta :article="article" />
            <div class="blog__articles-body d-flex">
                <h3 class="blog__articles-item-title">
                    <a :href="articleLink">{{ article.title }}</a>
                </h3>
                <div class="blog__articles-descr" v-text="striptagsContent"></div>
            </div>
            <article-media-nav class="blog__articles-footer" v-bind="mediaProps" />
        </div>
    </article>
</template>

<script>

import CategoryBadge from './CategoryBadge.vue'
import ArticleMediaNav from './ArticleMediaNav.vue'
import ArticleMeta from './ArticleMeta.vue'

export default {
    name: "Article",
    components: { CategoryBadge, ArticleMediaNav, ArticleMeta },
    
    props: {
        article: {
            type: Object,
            required: true,
        }
    },

    computed: {
        
        articleLink(){
            let { slug } = this.article
            let category = this.article.category.slug
            return `/blog/${category}/${slug}`
        },

        mediaProps(){
            let { comments_count, follow, id: post_id } = this.article

            return{
                post_id,
                follow,
                comments_count,
                link: this.articleLink
            }
        },


        headerStyles() {
            return {
                'background-image': (`url(/storage/${this.article.main_image.path})`).replace( 'original', 'preview_l' )
            }
        },

        striptagsContent() {
            return (this.article.content).replace(/<\/?[^>]+(>|$)/g, "")
        },

    }
}
</script>